import { Link } from 'react-router-dom';
import { categories, siteConfig } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading text-foreground-900 mb-4">{siteConfig.name}</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              正版成人游戏安全下载平台，严格筛选优质资源，支持多平台兼容，快速下载无广告骚扰。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">游戏分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">联系方式</Link>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-foreground-500">
                <i className="ri-mail-line mr-2"></i>
                {siteConfig.email}
              </p>
              <p className="text-sm text-foreground-500">
                <i className="ri-phone-line mr-2"></i>
                {siteConfig.phone}
              </p>
              <p className="text-sm text-foreground-500">
                <i className="ri-map-pin-line mr-2"></i>
                {siteConfig.address}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 仅供18岁以上用户访问
          </p>
          <p className="text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors">粤ICP备2024XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}